const pinDiameter = 20;
const pinRadius = pinDiameter / 2;
const gapInXAxis = pinRadius;
const gapInYAxis = pinRadius;
const pathColor = '#5D5D5D';
const padding = (1 / 3) * pinDiameter;
type PinColorType = {
  background: string;
  border: string;
  text: string;
};
enum PinState {
  FREE = 0,
  OCCUPIED = 1,
  SELECTED = 2,
  HOVER = 3,
  CURRENT = 4,
}

enum PuckType {
  ACTOR = 'ACTOR Puck',
  SPINE = 'SPINE Puck',
  UNI = 'Uni Puck',
  SSLR = 'SSLR Puck',
  ALS = 'ALS Puck',
}

enum PuckDewarContainerView {
  PuckDewarInfoView,
  SelectPuckView,
  SelectDewarView,
}

const sidePanelTitle: { [key in PuckDewarContainerView]: string } = {
  [PuckDewarContainerView.PuckDewarInfoView]: 'Puck and Dewar Options',
  [PuckDewarContainerView.SelectPuckView]: 'Select Puck',
  [PuckDewarContainerView.SelectDewarView]: 'Select Dewar',
};

const pinColor: { [key in PinState]: PinColorType } = {
  [PinState.FREE]: {
    background: '#4CAF50',
    border: '#5D5D5D',
    text: '#FFFFFF',
  },
  [PinState.OCCUPIED]: {
    background: '#F7A246',
    border: '#F7A246',
    text: '#000000',
  },
  [PinState.SELECTED]: {
    background: '#93C2FD',
    border: '#93C2FD',
    text: '#000000',
  },
  [PinState.HOVER]: {
    background: '#DAEAFE',
    border: '#93C2FD',
    text: '#000000',
  },
  [PinState.CURRENT]: {
    background: '#8B0000',
    border: '#8B0000',
    text: '#FFFFFF',
  },
};
enum PathType {
  STRAIGHT = 0,
  CIRCULAR = 1,
}

type NodeType = {
  x: number;
  y: number;
};
type CircularPathType = {
  radius: number;
  x: number;
  y: number;
};

type LabelType = { x: number; y: number; text: string };

type CanvasSizeType = { height: number; width: number };

export {
  PinState,
  pinColor,
  pinDiameter,
  pinRadius,
  gapInXAxis,
  gapInYAxis,
  pathColor,
  padding,
  sidePanelTitle,
  PathType,
  PuckType,
  PuckDewarContainerView,
};
export type { NodeType, CircularPathType, LabelType, CanvasSizeType };
